const updateAdministrationInfo = 'UPDATE_ADMINISTRATION_INFO';
const addLocationToList = 'ADD_LOCATION_TO_LIST';
const removeLocationFromList = 'REMOVE_LOCATION_FROM_LIST';
const submitFormular = 'SUBMIT_FORMULAR';
const receiveSaveConfirmation = 'RECEIVE_SAVE_CONFIRMATION';
const initialState = {
    Administration: {
        salutation: '02',
        title: '',
        street: ''
    },
    LocationRegistrations: [],
    LocationCancellations: [],
    isLoading: false,
    isSuccess: null
};


const locationRegistrationBaseUri = 'api/location/register';
const locationRemovalBaseUri = "api/location/cancel"

export const actionCreators = {
    // main actionCreators
    updateAdminInfo: adminInfo => (dispatch, getState) => {
        dispatch({ type: updateAdministrationInfo, adminInfo });
    },
    addLocationToList: (locationFromForm, targetList) => (dispatch) => {
        dispatch({ type: addLocationToList, locationFromForm, targetList });
    },
    removeLocationFromList: (indexOfLocation, targetList) => (dispatch) => {
        dispatch({ type: removeLocationFromList, indexOfLocation, targetList });
    },
    submitFormular: (targetList) => (dispatch, getState) => {
        dispatch({ type: submitFormular, targetList }); // sets loading status true for the next part

        const formType = targetList === 'LocationRegistrations' ? 'registration' : 'cancellation';
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        const request = new Request(
            formType === 'registration' ? locationRegistrationBaseUri : locationRemovalBaseUri,
            {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(
                    {
                        userData: getState().userData.Administration,
                        [formType]: getState().userData[targetList]
                    })
            });
        fetch(request)
            .then(
                // sets loading status false because calculation has ended
                response => dispatch({ type: receiveSaveConfirmation, response }),
                error => dispatch({ type: receiveSaveConfirmation, response: error })
            );
    },

    // used by them:
    addRegistration: (registrationLocation) => (dispatch) => {
        dispatch(actionCreators.addLocationToList(registrationLocation, 'LocationRegistrations'));
    },
    removeRegistration: (indexOfLocation) => (dispatch) => {
        dispatch(actionCreators.removeLocationFromList(indexOfLocation, 'LocationRegistrations'));
    },
    submitRegistration: () => (dispatch) => {
        dispatch(actionCreators.submitFormular('LocationRegistrations'));
    },
    addCancellation: (cancellationLocation) => (dispatch) => {
        dispatch(actionCreators.addLocationToList(cancellationLocation, 'LocationCancellations'));
    },
    removeCancellation: indexOfLocation => (dispatch) => {
        dispatch(actionCreators.removeLocationFromList(indexOfLocation, 'LocationCancellations'));
    },
    submitCancellation: () => (dispatch) => {
        dispatch(actionCreators.submitFormular('LocationCancellations'));
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {

        case updateAdministrationInfo:
            return {
                ...state,
                Administration: action.adminInfo
            };

        case removeLocationFromList:
            let list = [
                ...state[action.targetList].slice(0, action.indexOfLocation),
                ...state[action.targetList].slice(action.indexOfLocation + 1)
            ];
            return {
                ...state,
                [action.targetList]: list
            }

        case addLocationToList:
            return {
                ...state,
                [action.targetList]: state[action.targetList].concat(action.locationFromForm)
            };

        case submitFormular:
            return {
                ...state,
                isLoading: true
            };

        case receiveSaveConfirmation:
            if (action.response.status === 200) {
                return {
                    ...initialState,
                    isLoading: false,
                    isSuccess: true
                }
                // show partial success message
            } else if (action.response.status === 207){
                return {
                    ...initialState,
                    isLoading: false,
                    isSuccess: true,
                }

            } else {
                return {
                    ...initialState,
                    isLoading: false,
                    isSuccess: false,
                    errorCode: action.response.status + " - " + action.response.statusText
                };
            }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/UserData.js